export default __webpack_public_path__ + "static/media/js.43e744a2.svg";